export const ResConfig = {
  //资源根目录
  "root-address": "https://web-res-ccc.afunimg8.com/",
  //文件目录
  "files-address": "https://web-res-ccc.afunimg8.com/b_fun/files/",
  //游戏icon目录
  "game-icon-folder": "newres/gameicon_en6020",
  //游戏icon地址集合
  "game-icon": [
    "https://web-res-aaa.afunimg5.com/cdn-cgi/image/format=auto/",
    // 'https://web-res-ddd.afunimg6.com/cdn-cgi/image/format=auto/',
    // 'https://web-res-bbb.afunimg7.com/cdn-cgi/image/format=auto/',
    "https://web-res-ccc.afunimg8.com/cdn-cgi/image/format=auto/",
  ],
  //游戏icon图片文件类型
  "game-icon-type": "jpg",
  //游戏icon图片文件类型 - top10
  "game-icon-type-top10": "png",
  // winner游戏厂商图标
  "plat-icon-folder-winner": "newres/platicon_winner_dark",
  "plat-icon-folder": "newres/platicon",
};

export type TResConfig = keyof typeof ResConfig;
